import { OtherIncomeItem } from 'types/underwriting/income-approach';
import { PropertyType } from 'types/underwriting/property';
import { VCLossTypes } from './constants';

export const hasResidential = (propertyType: PropertyType): boolean => {
  return propertyType === 'mixed-use' || propertyType === 'multifamily';
};

export const hasCommercial = (propertyType: PropertyType): boolean => {
  return propertyType === 'mixed-use' || propertyType === 'commercial';
};

export const getOtherVCLossPercentage = (
  otherIncome: OtherIncomeItem,
  residentialVCLossPercentage: number,
  commercialVCLossPercentage: number
): number => {
  switch (otherIncome.vcLossType) {
    case VCLossTypes.RESIDENTIAL:
      return residentialVCLossPercentage;
    case VCLossTypes.COMMERCIAL:
      return commercialVCLossPercentage;
    default:
      return otherIncome.vcLossPercentage || 0;
  }
};
